import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { RadioGroup } from '@progress/kendo-react-inputs';
import { GearFieldWrapper } from '../GearFieldWrapper';
import { useGlobalizationContext } from '../../../../context/globalization/GlobalizationContext';
import { useTranslation } from '../../../../context/globalization/useTranslation';

export const FormBoolRadioGroup: React.FC<FieldRenderProps> = fieldRenderProps => {
  const { disabled } = fieldRenderProps;
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);

  const data = [
    {
      label: translate('custom.common.yes'),
      value: true
    },
    {
      label: translate('custom.common.no'),
      value: false
    }
  ];
  return (
    <GearFieldWrapper {...fieldRenderProps}>
      <RadioGroup
        data={data}
        value={fieldRenderProps.value}
        onChange={fieldRenderProps.onChange}
        valid={fieldRenderProps.valid}
        disabled={disabled}
      />
    </GearFieldWrapper>
  );
};
